export default class PayerState {
  constructor() {
    this.payerList = {
      loading: false,
      data: [],
      total: 0,
      error: null,
    };

    this.payerCompany = {
      loading: false,
      data: {},
      error: null,
    };

    this.deletePayerCompany = {
      loading: false,
      data: {},
      error: null,
    };

    this.payerContactPerson = {
      loading: false,
      data: {},
      error: null,
    };

    this.deletePayerContactPerson = {
      loading: false,
      data: {},
      error: null,
    };

    this.defaultPayer = {
      loading: false,
      data: {},
      error: null,
    };

    this.payerCompanies = {
      loading: false,
      data: [],
      error: null,
    };
  }
}
